import React from 'react';

import type { GalleryData } from '../../../types/blog';

interface GalleryProps {
  data: GalleryData;
}

const Gallery: React.FC<GalleryProps> = ({ data }) => {
  const images = data.images ?? [];
  const columns = data.columns ?? 2;

  if (images.length === 0) return null;

  const gridClass =
    columns === 1
      ? 'grid-cols-1'
      : columns === 3
      ? 'grid-cols-1 sm:grid-cols-3'
      : 'grid-cols-1 sm:grid-cols-2';

  return (
    <div className={`grid ${gridClass} gap-4 my-2`}>
      {images.map((img, i) => {
        const imageAlt = img.alt?.trim() || img.caption?.trim() || `Gallery image ${i + 1}`;
        return (
        <figure key={i} className="m-0">
          {img.url ? (
            <img
              src={img.url}
              alt={imageAlt}
              loading="lazy"
              className="w-full rounded-xl object-cover border vscode-border aspect-video"
            />
          ) : (
            <div className="w-full rounded-xl border-2 border-dashed vscode-border aspect-video flex items-center justify-center">
              <span className="text-xs vscode-text-secondary">Image {i + 1}</span>
            </div>
          )}
          {img.caption && (
            <figcaption className="mt-1.5 text-center text-xs vscode-text-secondary italic">
              {img.caption}
            </figcaption>
          )}
        </figure>
        );
      })}
    </div>
  );
};

export default Gallery;
